/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Button_Regenerate2Inputs */

const id_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasilkan Ulang Kunci`)
};

const ms_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janakan Semula Kunci`)
};

const da_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerér Nøgle`)
};

const de_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel neu generieren`)
};

const en_us2_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate Key`)
};

const es_es2_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerar clave`)
};

const es_mx2_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerar Key`)
};

const fil_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-regenerate ang Key`)
};

const fr_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régénérer la clé`)
};

const it_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rigenera chiave`)
};

const hu_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs újragenerálása`)
};

const nl_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleutel regenereren`)
};

const no_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerer nøkkel`)
};

const pl_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygeneruj ponownie`)
};

const pt_br2_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate Key`)
};

const pt_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerar chave`)
};

const ro_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerează cheia`)
};

const fi_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo uusi avain`)
};

const sv_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återskapa nyckel`)
};

const vi_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lại khóa`)
};

const tr_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtarı Yeniden Oluştur`)
};

const cs_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znovu vygenerovat klíč`)
};

const bg_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регенериране на ключ`)
};

const ru_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегенерировать ключ`)
};

const uk_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегенерувати ключ`)
};

const ar_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة إنشاء المفتاح`)
};

const hi_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुनः उत्पन्न`)
};

const th_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างคีย์ใหม่`)
};

const ja_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーを再生成`)
};

const zh_cn2_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate Key`)
};

const zh_hant1_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate Key`)
};

const ko_components_apikeymanager_button_regenerate2 = /** @type {(inputs: Components_Apikeymanager_Button_Regenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate Key`)
};

/**
* | output |
* | --- |
* | "Regenerate Key" |
*
* @param {Components_Apikeymanager_Button_Regenerate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_button_regenerate2 = /** @type {((inputs?: Components_Apikeymanager_Button_Regenerate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Button_Regenerate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "da") return da_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "de") return de_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "it") return it_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "no") return no_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "th") return th_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_button_regenerate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_button_regenerate2(inputs)
	return ko_components_apikeymanager_button_regenerate2(inputs)
});
export { components_apikeymanager_button_regenerate2 as "components.apiKeyManager.button.regenerate" }